/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { StickyContainer, Sticky } from "react-sticky";

/* components */
import ThemeForm from "./ThemeForm";
import { reformThemeData, addDuplicates, removeDuplicates } from "./changeThemeObject";
import Page from "../../shared/Page";
import ThemeTemplatePicker from "../../shared/ThemeTemplatePicker";
import * as themeActions from "../../../actions/themesActions";
import GetItem from "../../../helpers/dataProviders/getItem";
import * as constants from "../../../constants";
import defaultTheme from "./ThemeForm/defaultTheme";

class ThemeFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "A";
		this.label = "Theme";
		this.id = props.match.params.id ? props.match.params.id : 0;

		const initialThemeId = "159a1fe4a1f";
		const initialNavigationType = "sideMenu";

		this.state = {
			item: null,
			appetizeThemeId: null,
			navigationType: initialNavigationType,
			appetizeParams: encodeURIComponent(
				`{"firestoreThemeDocumentName": "${initialThemeId}", "isThemePreview": true, "navigationType": "${initialNavigationType}"}`
			),
			showPreview: false,
			responsivePreview: false,
			moduleId: null,
			appetizePaused: false,
			previewIsLoaded: false,
		};
	}

	componentDidMount() {
		window.addEventListener("message", this.appetizeListener, false);
		if (this.props.type === "new") {
			this.props.themeActions.pickingThemeTemplate();
		}
	}

	appetizeListener = event => {
		if (event.data === "firstFrameReceived") {
			if (this.state.appetizePage !== null) {
				setTimeout(() => {
					this.pickAppetizePage(this.state.appetizePage);
					setTimeout(() => {
						if (this.iframe) {
							this.iframe.contentWindow.postMessage({ type: "mouseclick", x: 200, y: 450 }, "*");
						}
					}, 1000);
					setTimeout(() => {
						if (this.iframe) {
							this.iframe.contentWindow.postMessage({ type: "mouseclick", x: 200, y: 450 }, "*");
						}
					}, 2000);
					setTimeout(() => {
						if (this.iframe) {
							this.iframe.contentWindow.postMessage({ type: "mouseclick", x: 200, y: 450 }, "*");
						}
					}, 3000);
				}, 100);
			}
		}
	};

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		const mergedTheme = reformThemeData(values, addDuplicates);

		switch (type) {
			case "new":
				createItem(mergedTheme, submitHandler);
				break;
			case "copy":
				copyItem(mergedTheme, submitHandler);
				break;
			case "update":
				updateItem(mergedTheme, submitHandler, id);
				break;
			default:
				break;
		}
	}

	upsertTheme = (values, formApi) => {
		let newValue = reformThemeData(values, removeDuplicates);
		this.setState({ item: newValue });
		setTimeout(() => {
			formApi.setValues(newValue);
		}, 300);
	};

	renderCreateForm = () => {
		return (
			<div className="ta-center">
				<ThemeForm
					actionType="new"
					onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
					initialValues={this.state.item}
					buttonLabel={`Create ${this.label}`}
					getFormApi={this.props.getFormApi}
					hasFormApi={this.props.hasFormApi}
					setAppetizePause={this.setAppetizePause}
					setAppetizeThemeId={this.setAppetizeThemeId}
					pickAppetizePage={this.pickAppetizePage}
					upsertTheme={this.upsertTheme}
					setNavigationType={this.setNavigationType}
					navigationType={this.state.navigationType}
				/>
			</div>
		);
	};

	getInitialValues = item => {
		return {
			card: defaultTheme.card,
			...item,
		};
	};

	renderCopyForm = () => {
		if (this.state.item === null) {
			GetItem(`/themes/${this.props.match.params.id}`).then(data => {
				data.data.name = `${data.data.name} (copy)`;
				this.setState({ item: reformThemeData(data.data, removeDuplicates) });
			});
		}
		return (
			<div className="ta-center">
				{this.state.item ? (
					<ThemeForm
						actionType="copy"
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
						initialValues={this.getInitialValues(this.state.item)}
						buttonLabel={`Create ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
						setAppetizePause={this.setAppetizePause}
						setAppetizeThemeId={this.setAppetizeThemeId}
						pickAppetizePage={this.pickAppetizePage}
						upsertTheme={this.upsertTheme}
						setNavigationType={this.setNavigationType}
						navigationType={this.state.navigationType}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	renderUpdateForm = () => {
		if (this.state.item === null) {
			GetItem(`/themes/${this.props.match.params.id}`).then(data => {
				this.setState({ item: reformThemeData(data.data, removeDuplicates) });
			});
		}
		return (
			<div className="ta-center">
				{this.state.item ? (
					<ThemeForm
						actionType="update"
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, this.state.item.id)}
						initialValues={this.getInitialValues(this.state.item)}
						buttonLabel={`Update ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
						setAppetizePause={this.setAppetizePause}
						setAppetizeThemeId={this.setAppetizeThemeId}
						pickAppetizePage={this.pickAppetizePage}
						upsertTheme={this.upsertTheme}
						setNavigationType={this.setNavigationType}
						navigationType={this.state.navigationType}
						id={this.state.item.id}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	setNavigationType = navigationType => {
		const { appetizeThemeId } = this.state;
		const themeId = appetizeThemeId || "159a1fe4a1f";
		this.setState({
			navigationType,
			appetizeParams: encodeURIComponent(
				`{"firestoreThemeDocumentName": "${themeId}", "isThemePreview": true, "navigationType": "${navigationType}"}`
			),
		});
	};

	setAppetizeThemeId = appetizeThemeId => {
		if (this.state.appetizeThemeId === null) {
			const { navigationType } = this.state;
			this.setState({
				appetizeThemeId,
				appetizeParams: encodeURIComponent(
					`{"firestoreThemeDocumentName": "${appetizeThemeId}", "isThemePreview": true, "navigationType": "${navigationType}"}`
				),
				showPreview: true,
			});
		}
		// if(moduleId && this.state.moduleId !== moduleId){
		// 	this.setState({
		// 		moduleId,
		// 		showPreview: true
		// 	});
		// }else if(!moduleId){
		// 	this.setState({
		// 		moduleId,
		// 		showPreview: false
		// 	});
		// }
		if (this.iframe) {
			this.iframe.contentWindow.postMessage("heartbeat", "*");
		}
	};

	pickAppetizePage = page => {
		if (page) {
			this.setState({ appetizePage: page });
			if (this.iframe) {
				this.iframe.contentWindow.postMessage({ type: "url", value: `verris-appetize://theme/${page}` }, "*");
				setTimeout(() => {
					this.iframe.contentWindow.postMessage({ type: "mouseclick", x: 200, y: 450 }, "*");
				}, 1000);
				setTimeout(() => {
					this.iframe.contentWindow.postMessage({ type: "mouseclick", x: 200, y: 450 }, "*");
				}, 2000);
			}
		}
	};

	setAppetizePause = appetizePaused => {
		if (appetizePaused !== this.state.appetizePaused) {
			this.setState({ appetizePaused });
		}
	};

	pickTheme = theme => {
		this.props.themeActions.pickingThemeTemplateFinished();
		this.setState({ item: reformThemeData(theme, removeDuplicates) });
	};

	previewContent = style => {
		const { appetizeParams, showPreview } = this.state;
		return (
			<div style={style}>
				<div className={`appetize-pause${this.state.appetizePaused ? " on" : ""}`}>
					<div className="appetize-pause-text">
						<i className="fal fa-pause-circle"></i>
						<div className="ta-center">Incomplete Data</div>
					</div>
				</div>
				{showPreview ? (
					<iframe
						ref={r => {
							this.iframe = r;
						}}
						targetorigin="apoc://"
						src={`https://appetize.io/embed/${constants.APPETIZE_PUBLIC_KEY}?device=iphone14pro&osVersion=26.0&scale=75&&autoplay=true&orientation=portrait&deviceColor=black&centered=true&xdocMsg=true&params=${appetizeParams}`}
						width="323px"
						height="696px"
						frameBorder="0"
						scrolling="no"
						title="Theme Preview"
					/>
				) : (
					<div>Add More Content to Preview</div>
				)}
			</div>
		);
	};

	render() {
		let content = "Loading";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				break;
		}

		const { showPreview, responsivePreview } = this.state;

		return (
			<Page title="My Theme">
				{this.props.type !== "new" || this.state.item ? (
					<React.Fragment>
						{showPreview && (
							<div className="preview-button-container">
								<button
									title="Preview Theme"
									className="btn btn-info btn-block"
									onClick={() => this.setState({ responsivePreview: true })}
								>
									Preview Theme
								</button>
							</div>
						)}
						{responsivePreview ? (
							<div className={`coverall more global-coverall${responsivePreview ? " on" : ""}`}>
								<div className="global-preview absolute-center global pop-up-box">
									<div className="responsive-preview">
										<button
											title="Hide Preview"
											className="btn btn-info btn-block m-bottom"
											onClick={() => this.setState({ responsivePreview: false })}
										>
											Hide Preview
										</button>
										<div className="phone-preview">{this.previewContent()}</div>
									</div>
								</div>
							</div>
						) : (
							<div className="page-contents">
								<div className="page-builder">{content}</div>
								<div className="page-gutter"></div>
								<StickyContainer className="phone-preview">
									<Sticky topOffset={-60}>
										{({ style }) => {
											let newStyle = Object.assign({}, style, { top: style.top + 60 });
											return this.previewContent(newStyle);
										}}
									</Sticky>
								</StickyContainer>
							</div>
						)}
					</React.Fragment>
				) : (
					<ThemeTemplatePicker pickTheme={this.pickTheme} />
				)}
			</Page>
		);
	}
}

const mapDispatchToProps = dispatch => ({
	themeActions: bindActionCreators(themeActions, dispatch),
});

ThemeFormWrapper.propTypes = {
	copyItem: PropTypes.func,
	createItem: PropTypes.func,
	cultures: PropTypes.array,
	getFormApi: PropTypes.func,
	hasFormApi: PropTypes.bool,
	items: PropTypes.array,
	match: PropTypes.object,
	type: PropTypes.string,
	updateItem: PropTypes.func,
};

export default connect(
	null,
	mapDispatchToProps
)(withRouter(ThemeFormWrapper));
